import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=dcdd954a&scoped=true&"
import script from "./Calendar.vue?vue&type=script&lang=ts&"
export * from "./Calendar.vue?vue&type=script&lang=ts&"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=dcdd954a&lang=scss&scoped=true&"
import style1 from "./Calendar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdd954a",
  null
  
)

export default component.exports